import { Component, ViewChild } from "@angular/core";
import {
  NavController,
  NavParams,
  Refresher,
  ModalController,
  Content,
  AlertController,
} from "ionic-angular";
import { Loading } from "ionic-angular";
import { LoadingController } from "ionic-angular";
import * as Enumerable from "linq";
import * as moment from "moment";
import { AddFormPage } from "../add-form/add-form";
import { NavEntity } from "../../models";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import { TimeProvider } from "../../providers/time/time";
import { DataProvider } from "../../providers/data/data";
import { DemoProvider } from "../../providers/demo/demo";

@Component({
  selector: "page-log-book",
  templateUrl: "log-book.html",
})
export class LogBookPage {
  nav: NavEntity;
  loading: Loading;
  logs: Array<any> = [];
  refresher: Refresher;
  filter: any = moment().format("MMM YYYY");
  months: Array<string> = new Array();
  monthlyLogs: any;
  selectedLogs: Array<any> = [];
  visibility: any;
  loadingData = true;
  visibilities = new Map<number, boolean>();
  @ViewChild("contentl") content: Content;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private loadingController: LoadingController,
    private modal: ModalController,
    private starms: StarmsClientProvider,
    private time: TimeProvider,
    private dataProvider: DataProvider,
    public demoProvider: DemoProvider,
    private alertCtrl: AlertController
  ) {
    let dateStart = moment().subtract(1, "year");
    let dateEnd = moment();
    let months = [];
    while (
      dateEnd > dateStart ||
      dateStart.format("M") === dateEnd.format("M")
    ) {
      months.push(dateStart.format("MMM YYYY"));
      dateStart.add(1, "month");
    }
    this.monthlyLogs = {};
    for (let month of months) {
      this.monthlyLogs[month] = new Array();
    }
    this.months = months;
  }

  ionViewDidLoad() {
    this.nav = this.navParams.data;
    this.getData(true);
  }

  getData(presentLoading: boolean) {
    let timeParams = this.time.getTimeParams(365);
    this.starms
      .get(["logbook", this.nav.getType() + "s", Number(this.nav.getId())], {
        from: timeParams.from,
        to: this.time.add(timeParams.to, 1, "d"),
      })
      .subscribe(
        (logs) => {
          this.organize(logs);
          this.changeFilter("all");
        },
        () => {}
      )
      .add(() => {
        this.loadingData = false;

        if (this.refresher) {
          this.refresher.complete();
        }
      });
  }

  organize(logs: Array<any>): void {
    this.logs = Enumerable.from(logs)
      .orderByDescending((x) => x["siteTime"])
      .toArray();
    const monthlyData = this.dataProvider.buildMonthlyLogBookData(this.logs);
    this.monthlyLogs = monthlyData.monthlyLogs;
    this.months = monthlyData.months.reverse();
  }

  changeFilter(filter: string): void {
    this.filter = filter;
    if (filter === "all") {
      this.selectedLogs = [];
      this.selectedLogs = this.logs;
    } else {
      this.selectedLogs = [];
      this.selectedLogs = this.monthlyLogs[filter];
    }
    this.content.scrollToTop();
  }

  refresh(refresher: Refresher): void {
    this.refresher = refresher;
    this.getData(false);
  }

  openModal(): void {
    let modal = this.modal.create(AddFormPage, { type: "log" });
    modal.present();
    modal.onDidDismiss((data) => {
      if (data.result) {
        this.getData(true);
        this.changeFilter(this.filter);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/log-book/log-book.ts